import { render } from "./app-svg.vue?vue&type=template&id=8714e794&ts=true"
import script from "./app-svg.vue?vue&type=script&lang=ts"
export * from "./app-svg.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__